import * as Inovx from '@shared';
import HomeConstants from '../constants/HomeConstants';

const HomeActions = {
    openSidebar() {
        Inovx.Shared.Flux.AppDispatcher.dispatch({ actionType: HomeConstants.HOME_OPEN_SIDEBAR });
    },
    closeSidebar() {
        Inovx.Shared.Flux.AppDispatcher.dispatch({ actionType: HomeConstants.HOME_CLOSE_SIDEBAR });
    },
    selectMenu(menu = '') {
        Inovx.Shared.Flux.AppDispatcher.dispatch({ actionType: HomeConstants.HOME_SELECTED_MENU, menu });
    },
    togglePageLoading(isLoading: boolean) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({ actionType: HomeConstants.HOME_PAGE_LOADING, isLoading });
    },
};

export default HomeActions;
